import styled from 'styled-components';
import { createStack } from '@famly/mf_layout_stack';
export const formRowE2eClass = 'form-row';
export const FormRow = styled(createStack({ alignItems: 'flex-start', gap: 3, marginBottom: 4 })).attrs({
    'data-e2e-class': formRowE2eClass,
}) `
    /* this ensures print layouts will not break the page within a row cutting off e.g. the title from input */
    break-inside: avoid;

    &:empty {
        display: none;
    }
`;
